export const getIsTechnicianRole = roleId => {
  // This util will check role is work as Technician
  return [9, 10].includes(roleId);
};
